import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    content: {
        padding: theme.spacing(3),
    },
    roleControl: {
        marginTop: theme.spacing(2),
    },
}))

export default useStyles
